import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AssetsStore, NotificationDetails, ViewStore } from '@coach-bot/data-access/shared';
import { TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '@shared/ui';
import { BehaviorSubject, Observable, combineLatest, filter, map, takeUntil } from 'rxjs';

@Component({
  selector: 'ui-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationPopupComponent extends AbstractComponent implements OnInit {
  readonly assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;
  readonly extensionIcon$: BehaviorSubject<string> = this.viewStore.extensionIcon$;
  readonly notificationDetails$: BehaviorSubject<NotificationDetails> = this.viewStore.notificationDetails$;

  readonly icon$: Observable<string> = combineLatest([this.assetsPath$, this.extensionIcon$]).pipe(
    map(([assetsPath, extensionIcon]: [string, string]) => `${assetsPath}/${extensionIcon}`),
  );

  title$: Observable<string>;
  messages$: Array<Observable<string>> = [];

  constructor(
    private assetsStore: AssetsStore,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private viewStore: ViewStore
  ) {
    super();
  }

  ngOnInit(): void {
    this.notificationDetails$
      .pipe(
        takeUntil(this.destroyed$),
        filter(data => !!data)
      )
      .subscribe((notificationDetails: NotificationDetails) => {
        this.title$ = this.translateService.stream(notificationDetails.title);
        if (typeof notificationDetails.message === 'string') {
          this.messages$ = [this.translateService.stream(notificationDetails.message)];
        } else {
          this.messages$ = notificationDetails.message.map((item: string) => this.translateService.stream(item));
        }
        this.changeDetectorRef.detectChanges();
      });
  }
}
